import { Security } from '@okta/okta-react'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { useHistory } from 'react-router-dom'
import { ReactNode, useCallback, useMemo } from 'react'

export function OktaProvider({ children }: { children: ReactNode }) {
  const history = useHistory()
  const oktaAuth = useMemo(
    () =>
      new OktaAuth({
        issuer: process.env.REACT_APP_OKTA_ISSUER as string,
        clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
        redirectUri: window.location.origin + '/auth/dnb/callback',
      }),
    []
  )

  const restoreOriginalUri = useCallback(
    async (_oktaAuth: any, originalUri: any) => {
      try {
        history.replace(toRelativeUrl(originalUri || '/', window.location.origin))
      } catch (error) {
        console.error(error)
      }
    },
    [history]
  )

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  )
}
